// extracted by mini-css-extract-plugin
export default {"content":"bigImg_content__VjS-x","photo":"bigImg_photo__4JG1e"};